"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsLetterForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../../utils/classNames");
const theme_1 = require("../../../../utils/theme");
const form_1 = require("../../../atomic/atoms/data-entry/form");
const input_1 = require("../../../atomic/atoms/data-entry/input");
const NewsLetterForm = ({ form, schemaKey = 'newsletter', title, }) => {
    const { register } = form;
    const theme = (0, theme_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(form_1.Form.Section, { title: title, children: (0, jsx_runtime_1.jsx)(form_1.Form.Control, { name: "email", label: "Email Address", children: (0, jsx_runtime_1.jsx)(input_1.Input, { ...register(`${schemaKey}.email`), className: (0, classNames_1.cn)(theme.components.newsLetter.emailInput) }) }) }));
};
exports.NewsLetterForm = NewsLetterForm;
